import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

const logApiError = (error: unknown) => {
	console.error("API request failed:", error);
};

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: { retry: 1, refetchOnWindowFocus: false },
	},
	queryCache: new QueryCache({ onError: logApiError }),
	mutationCache: new MutationCache({ onError: logApiError }),
});
